import React, { useState } from "react";

const Tabs = ({ tabsList, selectedIndex, interactive, onTabSelected }) => {
  const [activeTab, setActiveTab] = useState(selectedIndex);

  const handleTabClick = (index, tabName) => {
    setActiveTab(index);
    if (onTabSelected) {
      onTabSelected(tabName);
    }
  };

  return (
    <ul className="flex items-center justify-center gap-3">
      {tabsList.map((tab, index) => (
        <li key={index} className="flex-shrink-0">
          <button
            style={
              activeTab === index
                ? {
                  backgroundColor: "#f0f7ff",
                  color: "#1e3a8a",
                  borderRadius: "999px",
                  fontWeight: "700",
                  boxShadow: "0 2px 6px rgba(30, 58, 138, 0.1)",
                  border: "1px solid #cce3ff"
                }
                : {}
            }
            className={`inline-block py-1.5 px-3 text-xs transition-all duration-200 rounded-full whitespace-nowrap ${activeTab === index
                ? ""
                : interactive
                  ? "text-gray-950 font-bold hover:text-blue-700 hover:bg-blue-50"
                  : "text-gray-600 font-bold cursor-default"
              }`}
            onClick={interactive ? () => handleTabClick(index, tab.pageName) : undefined}
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
